<template>
  <div>
    <template v-if="plantsSharing.length !== 0">
      <div
        no-gutters
        v-for="plantSharing in plantsSharing"
        :key="plantSharing.id"
        class="px-3 mb-4"
      >
        <v-row no-gutters>
          <v-col align-self="center">
            <v-row no-gutters class="text-caption grey--text px-5"
              >Added
              {{
                handleISOToRelativeTime(plantSharing.createdAt.toDate())
              }}</v-row
            >
            <v-row
              no-gutters
              v-if="!plantSharing.descriptionSharing && !visitor"
              class="px-5"
              ><v-btn
                class="text-none rounded-pill mt-3 mb-4"
                depressed
                small
                color="primary"
                @click="
                  $store.commit('plants/setPlant', plantSharing),
                    (dialogDescription = true)
                "
                >Add a description</v-btn
              ></v-row
            >
            <v-row
              no-gutters
              v-if="plantSharing.descriptionSharing"
              align-self="center"
              class="secondary--text px-5 mb-2"
              style="white-space: pre-line"
              @click="editDescription(plantSharing)"
            >
              {{ plantSharing.descriptionSharing }}
            </v-row></v-col
          >
          <v-col cols="auto" align-self="center">
            <div
              v-if="plantSharing.loversId"
              class="mr-6"
              @click="
                toggleLove(
                  {
                    itemId: plantSharing.id,
                    parentId: plantSharing.userId,
                    target: 'plants',
                    self,
                    deep: true,
                  },
                  plantSharing
                )
              "
            >
              <span class="secondary--text text-h6 mr-1">{{
                plantSharing.loversId.length
              }}</span>
              <v-icon
                class="mb-2"
                :color="
                  plantSharing.loversId.includes(self.id)
                    ? 'primary'
                    : 'secondary'
                "
                >{{
                  plantSharing.loversId.includes(self.id)
                    ? "mdi-thumb-up"
                    : "mdi-thumb-up-outline"
                }}</v-icon
              >
            </div>
          </v-col>
        </v-row>

        <v-row
          no-gutters
          style="position: relative"
          class="px-3"
          @click="$router.push(`/garden/${gardenId}/plant/${plantSharing.id}`)"
        >
          <v-img
            class="shrink rounded-xl"
            :src="plantSharing.pictureUrl"
            transition="fade-transition"
            width="100%"
            height="200"
            ><template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-row>
            </template>
            <v-chip
              color="primary"
              class="ma-4"
              v-if="plantSharing.status === 'given'"
              style="position: absolute; z-index: 2; right: 0; bottom: 0"
              >Plant Given</v-chip
            >
            <div
              v-if="plantSharing.numberOfComments"
              style="
                position: absolute;
                z-index: 2;
                left: 18px;
                bottom: 9px;
                text-shadow: 0px 0px 2px rgba(150, 150, 150, 1);
              "
              class="white--text text-h6"
            >
              <div class="d-inline-block">
                {{ plantSharing.numberOfComments }}
              </div>
              <v-icon
                class="mr-0 ml-2 mt-n1"
                color="white"
                style="text-shadow: 0px 0px 2px rgba(150, 150, 150, 1)"
                >mdi-chat-outline</v-icon
              >
            </div></v-img
          >
        </v-row>
      </div>
    </template>

    <div v-else-if="plantsPending" class="px-6">
      <v-skeleton-loader
        type="image"
        class="my-4 rounded-xl"
        v-for="n in 2"
        :key="n"
        height="200"
        width="100%"
      ></v-skeleton-loader>
    </div>

    <template v-else>
      <v-row no-gutters justify="center" class="mt-10">
        <v-img
          alt="empty pots"
          class="shrink"
          src="/img/illustrations/pots.svg"
          style="filter: grayscale(1); opacity: 0.5"
          transition="scale-transition"
          width="110"
          height="100"
          contain
      /></v-row>
      <v-row no-gutters justify="center" class="mt-2 text-caption grey--text">
        No plant to give
      </v-row>
      <v-row no-gutters justify="center" class="mb-3">
        <label
          v-if="!visitor"
          for="add-plant-sharing"
          class="py-1 rounded-pill v-btn white--text px-4 my-6 text-none"
          style="background-color: var(--v-primary-base); height: 36px"
        >
          Add my first plant to give
        </label>
      </v-row>
    </template>

    <v-dialog
      v-model="dialogDescription"
      content-class="dialog-description"
      overlay-opacity="0.2"
      max-width="300"
      transition="dialog-top-transition"
      origin="center top"
      class="rounded-xl"
    >
      <v-card class="rounded">
        <v-form ref="form" lazy-validation v-model="valid">
          <v-row no-gutters justify="center" class="pa-2">
            <v-textarea
              color="primary"
              placeholder="Write a description"
              v-model="descriptionSharing"
              :rows="2"
              auto-grow
              autofocus
              solo
              flat
              :counter="150"
              :rules="descriptionRules"
              required
            ></v-textarea>
          </v-row>

          <v-row no-gutters justify="end">
            <v-btn
              class="ma-4 text-none rounded-pill"
              color="primary"
              depressed
              @click="validate"
              :disabled="!valid"
              >Add</v-btn
            >
          </v-row></v-form
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ISOToRelativeTime } from "@/utils/dates.js";

export default {
  name: "PlantsSharing",
  data() {
    return {
      valid: true,
      dialogDescription: false,
      descriptionSharing: "",
      descriptionRules: [
        (v) => !!v || "Description is required",
        (v) =>
          (v && v.length <= 150) || "Description must be max 150 characters",
      ],
    };
  },
  computed: {
    ...mapState("plants", ["plants", "plantsPending"]),
    plantsSharing() {
      return this.plants.filter((i) => {
        return i.status;
      });
    },
    gardenId() {
      return this.$route.params.gardenId;
    },
    visitor() {
      return this.gardenId !== this.self.id;
    },
    ...mapState("self", ["self", "selfPending"]),
  },
  watch: {
    dialogDescription(val) {
      if (!val) {
        this.$refs.form.resetValidation();
      }
    },
  },
  methods: {
    editDescription(plantSharing) {
      if (this.visitor) return;
      this.$store.commit("plants/setPlant", plantSharing);
      this.descriptionSharing = plantSharing.descriptionSharing;
      this.dialogDescription = true;
    },
    toggleLove(params, item) {
      if (item.loversId.includes(this.self.id)) {
        item.loversId = item.loversId.filter((i) => {
          return i !== this.self.id;
        });
      } else {
        item.loversId.push(this.self.id);
      }
      this.$store.dispatch("lovers/toggleLove", params);
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.save("descriptionSharing", this.descriptionSharing);
      }
    },
    async save(field, value) {
      if (value === "") return;
      let update = {};
      update[field] = value;
      this.dialogDescription = false;
      await this.$store.dispatch(`plants/updatePlant`, update);
      this.$store.commit(`snackbar/setSnackbar`, {
        color: "primary",
        timeout: 3000,
        text: "Modification saved",
      });
      this.descriptionSharing = "";
    },
    handleISOToRelativeTime(date) {
      return ISOToRelativeTime(date);
    },
  },
};
</script>